import type { ColumnGetter, HistoryStatusProps } from "./types";
import { Column } from "../../../repository";

export const useHistoryStatus = ({ row }: HistoryStatusProps) => {
    const from: <TStatus extends string>(mapper: Map<TStatus, string>) => ColumnGetter<
        | 'status'
        | 'fundStatus'
    > = <TStatus extends string>(mapper: Map<TStatus, string>) =>
            column => ({
                field: mapper.get(row[column]) as Column | undefined,
                value: row.updatedAt
            });

    return {
        from
    };
};

export default useHistoryStatus;
